{
    "general": {
        "buttons": {
            "newAddress": "Neue Adresse",
            "back": "zurück",
            "useAddress": "Verwenden",
            "closeModal": "Schließen",
            "confirmSelection": "Auswahl bestätigen",
            "addressesSelected": {
                "singular": "Adresse ausgewählt",
                "plural": "Adressen ausgewählt"
            },
            "cancel": "stornieren",
            "next": "Weiter",
            "addArea": "Gebiet hinzufügen"
        },
        "labels": {
            "zipcode": "Postleitzahl",
            "zipcodePlaceholder": "0000XX",
            "houseNumber": "Hausnummer",
            "streetName": "Straßenname",
            "streetNamePlaceholder": "Beispiel Straße",
            "addressFound": {
                "singular": "Adresse gefunden",
                "plural": "Adressen gefunden"
            },
            "houseNumberPlaceholder": "XX",
            "radiusLabel": "Radius (m)",
            "houseValueLabel": "Hauswert (x 1000 €)",
            "filterOn": "Filter auf",
            "filterRentalOption": "Vermietung",
            "filterSaleOption": "Verkauf",
            "addresses": {
                "singular": "Adresse",
                "plural": "Adressen"
            },
            "total": "Gesamt",
            "areas": "Bereiche",
            "selected": "ausgewählt",
            "houseType": "Haustyp",
            "allTypes": "Alle Arten",
            "clearSearch": "Suche löschen",
            "clearSelected": "Auswahl löschen",
            "noOptions": "Keine Optionen",
            "search": "Suche",
            "selectAll": "Alles auswählen",
            "selectAllFiltered": "Alles auswählen",
            "selectSomeItems": "Alle Arten",
            "create": "Erstellen"
        },
        "houseTypes": {
            "Appartement": "Appartement",
            "Vrijstaande woning": "Einfamilienhaus",
            "Tussenwoning": "Reihenhaus",
            "Hoekwoning": "Eckhaus",
            "2-onder-1-kapwoning": "Doppelhaushälfte"
        },
        "messages": {
            "addressNotFound": {
                "singular": "Keine Adresse gefunden",
                "plural": "Keine Adressen gefunden"
            },
            "addressNotFoundForSelected": "keine Adresse gefunden für:",
            "addressesNotFoundForSelection": "Keine Adressen zur Auswahl gefunden",
            "generalError": "Hoppla! Etwas ist schief gelaufen.",
            "addressLimitExceeded": {
                "singular": "Sie können nur {{max}} Adressen auswählen. {{count}} Adresse wird nicht ausgewählt.",
                "plural": "Sie können nur {{max}} Adressen auswählen. {{count}} Adressen werden nicht ausgewählt."
            },
            "addressMinimum": "Wählen Sie mindestens {{min}} Adressen aus, um fortzufahren.",
            "zipCodeAreaLimitError": "Es sollten mindestens {{limit}} Adressen pro Postleitzahlengebiet/Leitregion ausgewählt werden. Passen Sie Ihr Suchgebiet an, indem Sie den Radius vergrößern oder eine zweite Auswahl innerhalb der Leitregion hinzufügen.",
            "zipCodeAreaSelectionLimitError": "Es sollten mindestens {{limit}} Adressen pro Postleitzahlengebiet/Leitregion ausgewählt werden."
        }
    },
    "slideInPanel": {
        "header": {
            "title": "Adressen"
        },
        "tableColumnLabels": {
            "streetName": "Straßenname",
            "amountName": "Anzahl",
            "zipCodeArea": "Postleitzahlengebiet"
        },
        "content": {
            "noSelection": "Bitte wählen Sie einige Adressen im vorherigen Schritt aus"
        }
    },
    "summary": {
        "header": {
            "title": "Zusammenfassung"
        }
    },
    "filters": {
        "buttons": {
            "showMore": "Weitere filter anzeigen",
            "showLess": "Weniger filter anzeigen"
        },
        "household": {
            "label": "Haushaltsstruktur",
            "singles": "Einzelpersonen",
            "families": "Familien",
            "familiesWithSmallChildren": "Familien mit Kleinkindern ≤3 Jahre"
        },
        "buildingType": {
            "label": "Gebäudetyp",
            "appartment": "Appartement",
            "midTerraceHouse": "Reihenmittelhaus",
            "detachedHouse": "Freistehend",
            "terraceHouse": "Reihen-/Doppelhaus",
            "doubleHouse": "Doppelhaus",
            "smallBlockFlat": "Kleines MFH",
            "largeBlockFlat": "Großes MFH",
            "highRiseBuilding": "Hochhaus",
            "cornerHouse": "Eckhaus"
        },
        "buildingUsage": {
            "label": "Gebäudenutzung",
            "unknown": "Unbekannt",
            "residential": "Wohnhaus",
            "mixedUse": "Mischhaus",
            "commercial": "Gewerbehaus"
        },
        "buyRatio": {
            "label": "Filter auf Eigentümerquote"
        },
        "buildYear": {
            "label": "Filter auf Baujahr"
        },
        "livingArea": {
            "label": "Filter auf Wohnfläche"
        },
        "buildingSize": {
            "label": "Größe des Gebäudes / Wohnung ",
            "fam-1-2": "1-2 Familienh.",
            "fam-3-5": "3-5 Familienh.",
            "fam-6-9": "6-9 Familienh.",
            "fam-10-19": "10-19 Familienh.",
            "fam-20-plus": "20-größer Familienh."
        },
        "scaleText": {
            "extremeLow": "Extrem niedrig",
            "veryLow": "Sehr niedrig",
            "low": "Niedrig",
            "medium": "Mittel",
            "middleHigh": "Mitttel hoch",
            "high": "Hoch",
            "veryHigh": "Sehr hoch",
            "extremeHigh": "Extrem hoch"
        },
        "residenceLength": {
            "label": "Filter auf Wohndauer",
            "lessThanOneYear": "bis 1 Jahr",
            "betweenOneAndTwoYears": "bis 2 Jahre",
            "betweenTwoAndThreeYears": "bis 3 Jahre",
            "betweenThreeAndFourYears": "bis 4 Jahre",
            "betweenFourAndFiveYears": "bis 5 Jahre",
            "betweenFiveAndSixYears": "bis 6 Jahre",
            "betweenSixAndEightYears": "bis 8 Jahre",
            "betweenEightAndTenYears": "bis 10 Jahre",
            "moreThanTenYears": "mehr als 10 Jahre"
        },
        "purchasingPowerClass": {
            "label": "Filter auf Kaufkraftklasse",
            "farBelowAverage": "Stark unterdurchschnittlich",
            "belowAverage": "Unterdurchschnittlich",
            "lowerAverage": "Unterer Durchschnitt",
            "average": "Durchschnitt",
            "upperAverage": "Oberer Durchschnitt",
            "aboveAverage": "Überdurchschnittlich",
            "farAboveAverage": "Stark überdurchschnittlich"
        }
    }
}